import './ConnectionStatus.css'

interface ConnectionStatusProps {
  isConnected: boolean
  error: string | null
}

export default function ConnectionStatus({ isConnected, error }: ConnectionStatusProps) {
  if (error) {
    return (
      <div className="connection-status error">
        <span className="status-indicator"></span>
        <span>Connection error: {error}</span>
      </div>
    )
  }

  if (!isConnected) {
    return (
      <div className="connection-status connecting">
        <span className="status-indicator"></span>
        <span>Connecting...</span>
      </div>
    )
  }

  return (
    <div className="connection-status connected">
      <span className="status-indicator"></span>
      <span>Connected</span>
    </div>
  )
}


